import { modalReducer } from '@/core/features/modal';
import { snackbarReducer } from '@/core/features/snackbar';
import { loaderReducer } from '@/core/features/loader';
import { userReducer } from '@/slices/user';
import { sportsReducer } from '@/slices/sports';
import { matchesReducer } from '@/slices/matches';
import { logosReducer } from '@/slices/logos/slice';

export default {
  modal: modalReducer,
  snackbar: snackbarReducer,
  loader: loaderReducer,
  user: userReducer,
  sports: sportsReducer,
  matches: matchesReducer,
  logos: logosReducer,
};
